import { GET_BOOKS } from 'modules/v2/store/constants';

export const getBooks = () => ({
  type: GET_BOOKS,
});
